import { FC, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkPaymentStatus } from 'services/hotel';
import { BookCompleteResponse } from 'ts/hotel/interfaces/BookResponse';
import PaymentSkeleton from 'components/shared/PaymentSkeleton';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { getHotelIndex, getKey } from 'utils/hotel';
import { showPaymentLoader } from 'constants/generic';

import { HotelConfigContext } from 'contexts/HotelConfigContext';

const BookPayment: FC = () => {
  const [data, setData] = useState<BookCompleteResponse>();
  const {
    hotelIndex } = useContext(HotelConfigContext);
  const navigate = useNavigate();
  const location = useLocation();
  useGetPage('Hotels/Book');

  const timeout = useRef<any>();
  const [triesCount, setTriesCount] = useState(60);

  useEffect(() => {
    const newData = sessionStorage.getItem(getKey('bookPaymentHotels', hotelIndex));
    if (newData) {
      const newDataObj: BookCompleteResponse = JSON.parse(newData);
      setData(newDataObj);

      check(newDataObj);
    }

    return () => {
      clearTimeout(timeout.current);
    };
  }, [location]); // eslint-disable-line

  const check = async (data: BookCompleteResponse) => {
    setTriesCount((prev) => prev - 1);

    const responseCheck = await checkPaymentStatus(data.transactionId);

    if (responseCheck?.bookingModel?.statusGoToXX) {
      sessionStorage.removeItem(getKey('bookPaymentHotels', hotelIndex));
      navigate('/status-xx');
      sessionStorage.setItem(
        getKey('bookStatusXX', hotelIndex),
        JSON.stringify({
          orderId: responseCheck.bookingModel?.orderId,
          transactionId: data.transactionId,
          url: 'Hotels/SubmitScreenshots',
        })
      );
    } else if (responseCheck?.orderHasBeenPaid) {
      sessionStorage.setItem(
        getKey('bookSuccessHotels', hotelIndex),
        JSON.stringify({
          book: responseCheck.bookingModel,
          paxes: responseCheck.bookingModel.paxes,
          orderId: responseCheck.bookingModel.orderId,
          orderHasBeenPaid: responseCheck.orderHasBeenPaid,
          tranasctionId: data.transactionId,
          couponAmount: data.couponAmount,
        })
      );

      navigate(`/hotel${getHotelIndex(hotelIndex)}/success`);
    } else if (responseCheck?.hasErrors) {
      sessionStorage.setItem(getKey('errMessage', hotelIndex), responseCheck?.errorMessage);
      sessionStorage.setItem(
        getKey('bookFail', hotelIndex),
        JSON.stringify({
          orderId: responseCheck.bookingModel?.orderId,
          transactionId: data.transactionId,
          url: 'Hotels/SubmitScreenshots',
        })
      );
      navigate('/fail');
    } else if (triesCount > 0) {
      timeout.current = setTimeout(() => check(data), 5000);
    }
  };

  return (
    <div
      className="details-wrapper position-relative"
      style={{ justifyContent: 'center', height: 830 }}
    >
      
        <PaymentSkeleton systemProducts="Hotels" showPaymentLoader={showPaymentLoader} />

      {data?.paymentUrl && !data?.paymentUrl.includes('<iframe') && (
        <iframe
          src={data.paymentUrl}
          title="pay"
          width={470}
          height={577}
          style={{ marginTop: 35, zIndex: 1 }}
        />
      )}

      {data?.paymentUrl && data?.paymentUrl.includes('<iframe') && (
        <div
          className="book-payment-wr"
          dangerouslySetInnerHTML={{ __html: data.paymentUrl }}
        ></div>
      )}
    </div>
  );
};
export default withErrorBoundary(BookPayment, 'BookPayment');
